export default __webpack_public_path__ + "static/brightmind-fad600b1ff0a1ec04a28c3df72025595.svg";